import clsx from 'clsx';
import type { ModalReactElementProps } from '../../contexts/modal-context';
import { CountryInfoWithCurrency } from '../../types/country-info';
import { Modal } from '../Modal';

export type CurrencyChangePopupProps = ModalReactElementProps<
  {
    selectedRegion: string;
    countries: CountryInfoWithCurrency[];
  },
  string | undefined
>;

export function CurrencyChangeModal({
  selectedRegion,
  countries,
  close,
}: CurrencyChangePopupProps) {
  return (
    <Modal className="bg-checkout-card-gradient relative m-0 size-full rounded-none shadow-2xl md:h-auto md:max-w-[647px] md:rounded-xl md:p-8">
      <button
        type="button"
        onClick={() => close()}
        className="text-non-full-white hover:text-neon_yellow absolute right-2 top-2 size-8 text-3xl font-bold leading-none transition-colors duration-200"
      >
        ×
      </button>

      <div className="mt-16 flex flex-col items-center justify-center overflow-hidden tracking-normal md:mt-0 md:h-auto">
        <svg
          className="mb-2 inline-block size-10 align-middle text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>

        <div className="font-poppins mb-1 text-[22.5px] font-bold normal-case text-white">
          Select your region
        </div>
        <div className="font-poppins mb-8 max-w-[300px] text-center text-xs font-light normal-case text-[#979FAC] md:text-xs">
          Your selected region determines your currency and needs to match your billing region.
        </div>

        <div className="grid max-h-[60vh] w-full grid-cols-2 gap-3 overflow-y-auto px-4 md:max-h-[400px] md:grid-cols-3 md:gap-4 md:px-0">
          {countries.map(({
            code, name, currency, currencySymbol,
          }) => (
            <button
              type="button"
              key={code}
              onClick={() => close(code)}
              className={clsx(
                'flex flex-col items-start justify-center rounded border p-3 text-center transition-all duration-200',
                {
                  'border-[#B978FF] bg-[#B978FF]/10 text-[#B978FF] shadow-lg': selectedRegion === code,
                  'border-[#ECEAED33] bg-[#0E122C] text-[#ECEAED] hover:border-[#B978FF] hover:bg-[#B978FF]/10': selectedRegion !== code,
                },
              )}
            >
              <div className="mb-1 line-clamp-2 min-h-[2.5em] w-full text-left text-sm font-bold leading-tight md:min-h-0 md:text-base">
                {name}
              </div>
              <div className="text-[13.75px]">
                {currency}
                {' '}
                {currencySymbol}
              </div>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default CurrencyChangeModal;
